import { Component } from "@theme/component";
import { debounce, fetchConfig } from "@theme/utilities";

const ORDER_PREFIX = "Order Note：";
const VIDEO_PREFIX = "Free Personalized Video：";

let activeCartNoteFetch = null;

function buildCombinedCartNote() {
  const mainNoteInput = document.querySelector("[data-cart-note-main]");
  const videoNoteInput = document.querySelector("[data-cart-note-video]");

  const mainNote = mainNoteInput?.value?.trim() || "";
  const videoNote = videoNoteInput?.value?.trim() || "";

  return [
    mainNote ? `${ORDER_PREFIX}${mainNote}` : "",
    videoNote ? `${VIDEO_PREFIX}${videoNote}` : "",
  ]
    .filter(Boolean)
    .join("\n\n");
}

function syncHiddenCartNote() {
  const hiddenNoteInput = document.querySelector("[data-cart-note-hidden]");
  if (!hiddenNoteInput) return;

  hiddenNoteInput.value = buildCombinedCartNote();
}

/**
 * A custom element that displays a cart note.
 */
class CartNote extends Component {
  connectedCallback() {
    super.connectedCallback?.();

    syncHiddenCartNote();

    const cartForm = document.querySelector("#cart-form");
    if (cartForm && !cartForm.dataset.cartNoteMergeBound) {
      cartForm.dataset.cartNoteMergeBound = "true";

      cartForm.addEventListener("submit", () => {
        syncHiddenCartNote();
      });
    }
  }

  /**
   * Handles updates to the cart note.
   * @param {InputEvent} event - The input event in our text-area.
   */
  updateCartNote = debounce(async (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;

    const note = buildCombinedCartNote();

    syncHiddenCartNote();

    if (activeCartNoteFetch) {
      activeCartNoteFetch.abort();
    }

    const abortController = new AbortController();
    activeCartNoteFetch = abortController;

    try {
      const config = fetchConfig("json", {
        body: JSON.stringify({ note }),
      });

      await fetch(FoxTheme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Failed to update cart note:", error);
      }
    } finally {
      if (activeCartNoteFetch === abortController) {
        activeCartNoteFetch = null;
      }
    }
  }, 200);
}

if (!customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}